export enum FLEXIBLE_VOLUME_COMPONENT_TYPE {
    DROPDOWN = 'Dropdown',
    PLUSMINUS = 'PlusMinus',
}
